export const ContactsImageSources = {
    contactEmptyImage: '/images/contacts/contacts_empty_illustration.svg',
    contactEmptyBgImage: '/images/contacts/contacts_empty_state_bg.svg'
}
